module.exports = __webpack_public_path__ + "img/step3.f1e726de.png";